import { getConfig } from '@b2ag/micro-front-tools'

type ValueOf<T> = T extends Record<PropertyKey, infer V> ? ValueOf<V> : T

export const appBrands = {
  default: 'aladin',
  Aladin: 'aladin',
  Farmi: 'farmi',
  Episens: 'episens',
  UMG_US: 'umg-us',
} as const

export type AppBrand = ValueOf<typeof appBrands>

export let currentAppBrand: ValueOf<typeof appBrands>

export function getCurrentAppBrand() {
  return getConfig('APP_CONTEXT') || appBrands.default
}

currentAppBrand = getCurrentAppBrand()

const isCurrentBrand = (brand: ValueOf<typeof appBrands>) => currentAppBrand === brand

export const isAladin = isCurrentBrand(appBrands.Aladin)
export const isFarmi = isCurrentBrand(appBrands.Farmi)
export const isEpisens = isCurrentBrand(appBrands.Episens)
export const isUMG_US = isCurrentBrand(appBrands.UMG_US)

export function getBrandName(): "Aladin.farm" | "Farmi" | "Episens" | "CMG" | undefined {
  if (isAladin) {
    return 'Aladin.farm'
  }
  if (isFarmi) {
    return 'Farmi'
  }
  if (isEpisens) {
    return 'Episens'
  }
  if(isUMG_US) {
    return 'CMG'
  }
}
